import { Typography } from '@mui/material';
import {
  ConversationMessageContentType,
  type IConversationMessage,
} from 'src/@types/conversation';
import { useLocales } from 'src/locales';

type Props = {
  message: IConversationMessage;
};

export const ChatMediaNotification = ({ message }: Props) => {
  const { translate } = useLocales();

  return message.contentType === ConversationMessageContentType.IMAGE ? (
    <Typography variant="body2">
      {translate('shared.labels.sent_an_image')}
    </Typography>
  ) : (
    <Typography variant="body2">
      {translate('shared.labels.sent_a_video')}
    </Typography>
  );
};
